import { Unit } from "uom";
//SquareRootPressure
export var SquareRootPascal = Unit.createBase("SquareRootPascal", "SquareRootPressure", "√Pa");
export var SquareRootInchOfWaterColumn = Unit.timesNumber("SquareRootInchOfWaterColumn", 1 / 0.06335029447, SquareRootPascal);
//# sourceMappingURL=square-root-pressure.js.map